var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnBtnDeleteInCircle = function SvgIcnBtnDeleteInCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1A1A1A",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7915 7.6C19.7915 7.93137 19.5229 8.2 19.1915 8.2L12.8126 8.2C12.4812 8.2 12.2126 7.93137 12.2126 7.6C12.2126 7.26863 12.4812 7 12.8126 7L19.1915 7C19.5229 7 19.7915 7.26863 19.7915 7.6ZM21.9074 23V11.0421H10.0969V23C10.0969 23.4418 10.4551 23.8 10.8969 23.8H21.1074C21.5492 23.8 21.9074 23.4418 21.9074 23ZM8.89689 11.0421V23C8.89689 24.1046 9.79232 25 10.8969 25H21.1074C22.212 25 23.1074 24.1046 23.1074 23V11.0421L25.3494 11.0421C25.6808 11.0421 25.9494 10.7735 25.9494 10.4421C25.9494 10.1107 25.6808 9.84211 25.3494 9.84211H23.1074H21.9074H10.0969H8.89689L6.65469 9.84211C6.32332 9.84211 6.05469 10.1107 6.05469 10.4421C6.05469 10.7735 6.32332 11.0421 6.65469 11.0421L8.89689 11.0421ZM13.9495 13.6316C14.2808 13.6316 14.5495 13.9002 14.5495 14.2316V20.6105C14.5495 20.9419 14.2808 21.2105 13.9495 21.2105C13.6181 21.2105 13.3495 20.9419 13.3495 20.6105V14.2316C13.3495 13.9002 13.6181 13.6316 13.9495 13.6316ZM18.6232 14.2316C18.6232 13.9002 18.3546 13.6316 18.0232 13.6316C17.6919 13.6316 17.4232 13.9002 17.4232 14.2316V20.6105C17.4232 20.9419 17.6919 21.2105 18.0232 21.2105C18.3546 21.2105 18.6232 20.9419 18.6232 20.6105V14.2316Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnBtnDeleteInCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_btn_delete_in_circle.5b5fd7f9.svg";
export { ForwardRef as ReactComponent };